import { ExportOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { exportMfaLogs } from "../../services/mfaLogger";

export const ExportLogs = () => {
  const handleCancel = () => {
    Modal.confirm({
      title: "Are you sure you want to export the logs?",
      onOk: () => exportMfaLogs()
    });
  };

  return (
    <>
      <ExportOutlined style={{ fontSize: 25, color: "white", marginLeft: 10, cursor: "pointer" }} onClick={handleCancel} />
    </>
  );
};
